export default {
    code: `
// 点击右侧打开音乐效果更佳哦
Lovers = {'金晓凯': 😆, '包雅婷': 😊};
😆.say('😆嫁给我吧!❤️');
😊.response('😊好的吧~');
hat  (🎩,👒);
smile(😆,😊);
cloth(👔,👚);
shoes(👞,👠);
generateInvitation(😆,💍,😊);
// 我要开始讲我们的故事啦`,
//     code: `
// 我要开始运行啦`,
    executions: [{
        name: '感觉哪里见过你(2008年:🎵确认过眼神我遇上对的人)',
        time: '',
        duration: 0,
        visible: false
    }, {
        name: '会在何处见到你(2021年5月30日前:🎵我以为你懂得每当我看着你)',
        time: '',
        duration: 1,
        visible: false
    }, {
        name: '命中注定再见你(2021年5月30日:🎵天青色等烟雨而我在等你)',
        time: '',
        duration: 1,
        visible: false
    }, {
        name: '恋爱了(2021.6.20至今:🎵果汁分你一半爱相互扶搀)',
        time: '',
        duration: 1,
        visible: false
    }, {
        name: '冷战(🎵争吵过后还是想要爱你的冲动)',
        time: '',
        duration: 1,
        visible: false
    }, {
        name: '和好咯(🎵再有一万年深情也不变,爱像烈火般蔓延)',
        time: '',
        duration: 1,
        visible: false
    }, {
        name: '养只猫🐈(菜包)',
        time: '',
        duration: 0,
        visible: false
    }, {
        name: '养只狗🐕(等结婚后再领他/她回家吧)',
        time: '',
        duration: 0,
        visible: false
    }, {
        name: '结婚吧(🎵漫漫长路爱是莫忘最初)',
        time: '',
        visible: false
    }],
    barrages: [
        '新郎:我的新娘最好看',
        '66666666',
        '百年好合',
        '你的邀请函真是美',
        '哇！好棒！',
        '啥时候生娃',
        '哇哇哇',
        '66666',
        '一定来！！！',
        '祝福',
        '新娘很漂亮哦',
        '百年好合',
        '😗 😙 😚 😋 ',
        '666666',
    ],
}